function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import SearchBoxComponent from '../../components/Search/SearchBox';
import { geocoderClear, geocoderSearch } from '../../store/actions/geocoder';
import { search, suggest } from '../../store/actions/search';
import { getHash, setHash } from '../../utils/urlUtils';

/**
 * This component provides the functionality to apply a search criteria to the dadaset.
 * It should be used in pair with the Suggestions component
 */
function SearchBox(props) {
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (state) {
      var _state$dataset;
      return state === null || state === void 0 ? void 0 : (_state$dataset = state.dataset) === null || _state$dataset === void 0 ? void 0 : _state$dataset.search;
    }),
    masks = _useSelector.masks,
    text = _useSelector.text;
  var handleSearch = function handleSearch(value, action) {
    var hash = getHash('masks');
    if (action === 'remove') {
      if (hash.length < 0) hash = '';
      hash.splice(hash.indexOf(value), 1);
      setHash('masks', [].concat(hash));
    }
    setHash('page', '');
    dispatch(search(value, action));
  };
  return /*#__PURE__*/React.createElement(SearchBoxComponent, _extends({
    text: text,
    masks: masks,
    onSubmit: function onSubmit(value) {
      return handleSearch(value, 'add');
    },
    onUpdate: function onUpdate(value) {
      return value && dispatch(suggest(value));
    },
    onRemove: function onRemove(value) {
      return handleSearch(value, 'remove');
    },
    onGeocodeSearch: function onGeocodeSearch(value) {
      return dispatch(geocoderSearch(value));
    },
    onGeocoderClear: function onGeocoderClear() {
      return dispatch(geocoderClear());
    }
  }, props));
}
SearchBox.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Identifies if geocoder search functionality should be enabled or not */
  geocoding: PropTypes.bool,
  /**
   * A render function that is used to display the a UI based on the provided data and methods.  Either the single function as a child this prop should be provided
   * @function
   * @param {Object} props
   * @param {string} props.searchText The text that was last provided for suggestions
   * @param {Array} props.searchMasks The currently applied search masks
   * @param {Object} methods
   * @param {function} methods.onSearch A method to call when a suggested mask is applied
   * @param {function} methods.onUpdate A method to call when the search text input is updated
   * @param {function} methods.onRemove A method to call when an applied mask is removed from the search criteria
   *  */
  render: PropTypes.func
} : {};
SearchBox.defaultPropTypes = {
  geocoding: true
};
export default SearchBox;